/** Maximum overflow count to display before showing "+99" */
export const MAX_OVERFLOW_DISPLAY = 99;
